import { create } from 'zustand';

export enum NavigationPage {
    Login = 'login',
    Cards = 'cards',
}


// 1. Define types for your data structures
interface NavigationState {
    page: NavigationPage;
}


interface NavActions {
    setPage: (page: NavigationPage) => void;
}

// Combine both interfaces for the complete Store type
type NavStore = NavigationState & NavActions
const useNavStore = create<NavStore>((set) => ({
    page: NavigationPage.Login, // Default starting screen

    // Action to change views
    setPage: (page) => { set({ page: page }) },
}));

export default useNavStore;